<template>
  <div class="uninvoiced-wrapper">
 
    <div v-if="dataList.length" class="uninvoiced-container">
      <div class="main-content">
        <scroll
          :data="dataList"
          :pullup="pullup"
          :pulldown="pulldown"
          :probe-type="probeType"
          :listenScroll="listenScroll"
          @scroll="scroll"
          @pulldown="loadData"
          @scrollToEnd="scrollToEnd"
          class="listview"
          ref="listview"
        >
          <div class="list-content-wrapper">
            <ul ref="listGroup" class="list-content" v-for="(list,index) in dataList" :key="index">
              <p class="tiemr border1-top ft14">{{list.date}}</p>
              <li
                v-for="(item,index) in list.orderInfos"
                :key="index"
                @click="select(item)"
                class="list-item border1-top gray-3"
              >
                <div class="left">
                 
                  <span  :class="item.check?'tcicon-radio-on':'tcicon-radio-off'"></span>
                  <!-- <span class="radio" :class="item.check?'selected':'unselected'"></span> -->
                </div>
                <div class="middle gray-3 ft14">
                  <p pver90>{{item.useTime}}</p>
                  <p pver90>{{item.startAddress}}</p>
                  <p pver90>{{item.endAddress}}</p>
                </div>
                <div class="right gray-3">
                  <span class="money  ft20">{{item.totalAmount}}</span>
                  <span class="ft14">元</span>
                </div>
              </li>
            </ul>
            <div class="hasMore" v-if="hasMore">加载更多...</div>
            <!-- <div class="hasMore" v-if="!hasMore">没有更多啦...</div> -->
          </div>
          <!-- <div class="list-fixed ft14" ref="fixed" v-show="fixedTitle">
            <div class="fixed-title border1-bottm ">{{fixedTitle}}</div>
          </div> -->
        </scroll>
      </div>
      <div class="sticky-wrapper">
        <div class="sticky-left">
          <div class="check-all" @click="selectAll">
              <span :class="checkAllBtnFlag?'tcicon-radio-on':'tcicon-radio-off'"></span>
            <span class="select-all-text">全选</span>
          </div>
          <div class="detailed ft13">
            <p>
              行程:
              <span>{{stroke}}个</span>
            </p>
            <p>
              总额:
              <span>{{price.toFixed(2)}}元</span>
            </p>
          </div>
        </div>
        <div class="sticky-right ft14" :class="btnFalg?'selected':'unSelected'" @click="nextPage">下一步</div>
      </div>
    </div>
    <div v-if="nodata" class="no-data cen-start column">
      <img class="noInvoiceImg" src="https://file.40017.cn/groundtrafficstage/usecar/distributioncomponents/img/none_invoice.png" />
      <div class="tips">暂无可开发票行程</div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import * as api from "@/api";
import Scroll from '@/components/scroll';
var isBack;
export default {
  data() {
    return {
      scrollY: 0,
      currentIndex: 0,
      pullup: true,
      pulldown: true,
      probeType: 3,
      listenScroll: true,
      tabTitle: '发票', //title
      pageNo: 1, //当前页数
      totalPage: 1, //总页数
      hasMore: false, //是否加载更多
      isLoading: false, //正在加载中
      checkList: [], //单选 选中的list
      cancleList: [], //取消选中的 list（全选的 取消  时候  使用）
      checkAll: false, //是否选中所有
      stroke: 0, //选择的行程数
      totalPrice: 0,
      totalStroke: 0,
      dataList: [],
      listHeight: [],
      nodata: false
    };
  },
  watch: {
    dataList() {
      setTimeout(() => {
        this.calculateHeight();
      }, 20);
    },
    scrollY(val) {
      const listHeight = this.listHeight;
      // 当滚动到顶部，val>0
      if (val > 0) {
        this.currentIndex = 0;
        return;
      }
      //判断当前 滑动的位置在哪个区间
      for (let i = 0; i < listHeight.length - 1; i++) {
        let height1 = listHeight[i];
        let height2 = listHeight[i + 1];

        if (-val >= height1 && -val < height2) {
          this.currentIndex = i;
          console.log(this.currentIndex);
          return;
        }
      }
      console.log('listHeight', listHeight);
      this.currentIndex = listHeight.length - 2;
    }
  },
  computed: {
    btnFalg() {
      if (this.checkAll) {
        return true;
      } else if (this.checkList.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    checkAllBtnFlag() {
      if (this.checkAll) {
        if (this.cancleList.length) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    fixedTitle() {
      if (this.scrollY >= 0 && this.currentIndex == 0) {
        return '';
      }
      return this.dataList[this.currentIndex]
        ? this.dataList[this.currentIndex].date
        : '';
    },
    price() {
      //计算价格
      //总价减掉取消勾中的价格
    
      if (this.checkAll) {
        if (this.cancleList.length == 0) {
          this.stroke = this.totalStroke;
          return this.totalPrice;
        } else {
          let pric = 0;
          console.log(pric);
          let result = 0; 
          this.stroke = this.totalStroke - this.cancleList.length;
          this.cancleList.map(item => {
            result += (item.totalAmount * 100);
          });
          pric = (this.totalPrice * 100 - result) / 100;
          console.log(pric);
          return pric;
        }
      } else {
        //计算当前选中的价格
        let pric = 0;
        this.stroke = this.checkList.length;
        this.checkList.map(item => {
          pric = (pric * 100 + item.totalAmount * 100) / 100;
        });
        return pric;
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == '/receipt/invoiceform') {
      isBack = true;
    } else {
      isBack = false;
    }
    next();
  },

  activated() {
    this.tabTitle = '发票';
    //判断路由  如果是订单
    // if (!isBack)  {
      this.dataList = [];
      this.loadData();
    // }
  },
  methods: {
    //获取可开票的行程
    getReceiptList() {
      this.isLoading = true;
   
        api.getUnInvoiceList(
          {
            page: this.pageNo,
            size: 15
          },
         
        ).then( res => {
            const {data} = res;
            console.log('pageNo', this.pageNo);
            console.log('分页数据', data);
            if (res.code == 200) {
              // console.log(data);
              this.isLoading = false;
              this.totalPage = data.totalPage;
              if (this.pageNo < this.totalPage) {
                this.hasMore = true;
              } else {
                this.hasMore = false;
              }
              let traveList = data.travelListList;
              if (this.checkAll) {
                //遍历数据 修改为选中拼接数据
                traveList.map(item => {
                  item.orderInfos.map(val => {
                    val.check = this.checkAll;
                  });
                });
              }
              if (this.pageNo == 1) {
                if (!traveList.length) {
                  this.nodata = true;
                }
                this.dataList = traveList;
              } else {
                this.$refs.listview.$emit('finishLoad');
                if (traveList.length) {
                  if (
                    this.dataList[this.dataList.length - 1].date ==
                    traveList[0].date
                  ) {
                    //判断如果是返回的数据 是同一个月份 进行 数据的 处理
                    this.dataList[this.dataList.length - 1].orderInfos.push(
                      ...traveList.shift().orderInfos
                    );
                  }
                }
                this.dataList = [...this.dataList, ...traveList];
              }
            }
          });
      // });
    },
    //获取 行程总数信息
    getTravelAmount() {
        api.getTravelAmount({ }).then( res => {
          console.log('发票',res)
            //行程总数
            if (res.code == 200) {
              this.totalPrice = res.data.totalAmount;
              this.totalStroke = res.data.travelAmount;
            }
          })
    
    },
    //单个选中 是否 开票
    select(item) {
      console.log('item: ', item);
      if (this.checkAll) {
        let cancleList = this.cancleList;
        if (item.check) {
          //取消选中 向 cancalList push
          this.cancleList.push(item);
        } else {
          cancleList.splice(cancleList.findIndex(val => val.orderId === item.orderId), 1);
          //选中 向数组删除选中的
        }
        if (this.totalStroke != 0 && this.cancleList.length == this.totalStroke) {
          this.checkAll = false;
          this.cancleList = [];
        }
      }else{
      }
      // 未勾中 非选 下的逻辑处理
      if (!this.checkAll) {
        if (item.check) {
          //单选 取消选中
          console.log(item);
          let checkList = this.checkList;
          // checkList.splice( JSON.stringify(checkList).indexOf(JSON.stringify(item)),1)
          checkList.splice(
            checkList.findIndex(val => val.orderId === item.orderId), 1);
          console.log(this.checkList);
        } else {
          //单选  选中
          this.checkList.push(item);
          console.log(this.checkList);
        }
        if (this.totalStroke != 0 && this.checkList.length == this.totalStroke) {
          this.checkAll = true;
          this.checkList = [];
        }
      }
     
      item.check = !item.check;
    },
    selectAll() {

      if (this.checkAll && this.cancleList.length) {
        this.cancleList = [];
      } else {
        this.checkAll = !this.checkAll;
      }

      if (this.checkAll) {
        this.checkList = [];
      } 
      Object.values(this.dataList).map(item => {
        item.orderInfos.map(val => {
          val.check = this.checkAll;
        });
      });
    },
    nextPage() {
      if (this.btnFalg) {
        let orderIds;
        if (this.checkAll) {
          //全选的发送  取消的  orderIds
          orderIds = this.cancleList.map(item => item.orderId).join();
          console.log('orderIds: ', orderIds);
        } else {
          //单选 发送选中的
          orderIds = this.checkList.map(item => item.orderId).join();
          console.log('我是单个发票', orderIds);
        }
        let query = {
          hasCheckAll: this.checkAll,
          orderIds
        };
        
          
        
          this.$router.push({
            path: '/receipt/invoiceform',
            query: query
          });
          // const options = {
          //   price: this.price,
          //   ctx: this,
          //   orderId: orderIds,
          //   callback,
          //   wxquery: query
          // };

          // invoiceOrderFor(options, CHANNAL_ID);

        console.log('开票 query', query);
      }
    },
    pageCB() {
      this.$router.back(-1);
    },
    scroll(pos) {
      this.scrollY = pos.y;
    },
    getPage() {},
    loadData() {
      // this.dataList=[];
      this.pageNo = 1; //当前页数
      this.totalPage = 1; //总页数
      this.hasMore = false; //是否加载更多
      this.isLoading = false; //正在加载中
      this.checkList = []; //单选 选中的list
      this.cancleList = []; //取消选中的 list（全选的 取消  时候  使用）
      this.checkAll = false; //是否选中所有
      this.stroke = 0; //选择的行程数
      this.totalPrice = 0;
      this.totalStroke = 0;
      //请求
      this.getTravelAmount();
      this.getReceiptList();
      // this.reset();
    },
    scrollToEnd() {
      console.log('拉到底部了 分页请求数据');
      if (this.isLoading || !this.hasMore) {
        console.log('11111111');
        console.log(this.isLoading);
        console.log(this.pageNo, this.totalPage);
      } else {
        this.pageNo += 1;
        this.getReceiptList();
      }
    },
    //将元素的 缺件位置保存在数组中
    calculateHeight() {
      this.listHeight = [];
      const list = this.$refs.listGroup || [];
      console.log(list);
      let height = 0;
      this.listHeight.push(height);
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        height += item.clientHeight;
        this.listHeight.push(height);
      }
    }
  },
  components: {
    Scroll
  }
};
</script>
<style lang="less" scoped>
.list-fixed {
  // position: absolute;
  // z-index: 9999;
  // top: 60px;
  // left: 0;
  // width: 100%;
  .fixed-title {
    height: 20px;
    line-height: 20px;
    padding-left: 10px;
    color: #999;
    background: #fff;
  }
}
.listview {
  height: 100%;
  overflow: hidden;
  position: relative;
}
.uninvoiced-wrapper {
  // position: fixed;
  // top: 44px;
  // bottom: 0;
  width: 100%;
  // overflow: hidden;
  display: flex;
  flex: 1;
  flex-direction: column;
}
.uninvoiced-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.main-content {
  // flex: 1;
  position: fixed;
  width: 100%;
  top: 44px;
  bottom: 0;
  // bottom: 3rem;
  overflow: hidden;
  .list-content-wrapper{
    padding-top:44px; 
    // margin-top:44px; 
    padding-bottom:60px;
  .list-content {
    .tiemr {
      height: 40px;
      line-height: 40px;
      padding-left: 20px;
      background: #f1f2f6;
      color: #999;
    }

    .list-item {
      color: #666;
      padding: 20px;
      background: #fff;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-align-content: center;
      -ms-flex-line-pack: center;
      align-content: center;
      -webkit-flex-wrap: nowrap;
      -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
      .left {
        width: 32px;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
      }
      .middle {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        -ms-flex: 1;
        flex: 1;
        width: 100%;
        overflow: hidden;
        position: relative;
        p {
          height: 23px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .right {
        min-width: 80px;
        text-align:right;
        font-size: 0;
        font-weight:bold;
        position: relative;
        .money {
          line-height:22px;
          display: inline-block;
          padding-left: 40px;
        }
      }
    }
  }
  }
}
.sticky-wrapper {
  width: 100%;
  height: 60px;
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 99;
  display: flex;
  align-items: center;
  .sticky-left {
    flex: 1;
    display: flex;
    height: 60px;
    align-items: center;
    background: rgba(0,0,0,0.8);
    .check-all {
      width: 134px;
      padding-left: 20px;
      display: flex;
      height: 60px;
      align-items: center;
      font-size: 14px;
      color: #ffffff;
      .select-all-text {
        margin-left: 5px;
      }
    }
    .detailed {
      flex: 1;
      color: #ffffff;
      font-size: 13px;
      span {
        color: orangered;
      }
    }
  }
  .sticky-right {
    width: 135px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-weight: bold;
    color: #fff;
  }
  .selected{
    background: #FE5043;
  }
  .unSelected{
    background: #aaa;
  }
  .active {
    background-color: black;
    color: #fff;
  }
}

.radio {
  display: inline-block;
  min-width: 20px;
  min-height: 20px;
  border-radius: 50%;
  box-sizing: border-box;
  
}
.tcicon-radio-on{
  color: #FE5043;
  font-size:20px;
}
.tcicon-radio-off{
  font-size:20px;
  color:#ddd;
}
.unselected {
  border: 1px solid #ddd;
}

.selected {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAAAXNSR0IArs4c6QAABX5JREFUaAXdmj9sHEUUxmf27BQ5iGIEjmhIFJ8JRaBAJEgISILuUiSQitBB6TtDCqpUFBRUSAiETOwzHekIDZEIUu6S2FAgFIUCBQljhz8NAiVSpEQiQcY3fN/czmq8t7s3t95br3zNzs7Mzny/e7tv3uxbKTL8KaXkRLu+XwrvkFCd/ULKfajbLaXcIZR6UE8l5V3U3UHdH6hbEtK7rkRn8Ua1eR11Kis5cqMDEebxy40X1tbEG1KoE1D2SJoxIeSmEvJ8qSQ+++WluW83CpkajECT7emTSqj3UJ5MAxN3DaCWpZDvLFdnz6UFTAVWaTUOd0TnfaHEgThxmdRLcdUT3umV2tzCoOMNBPbElcae1f/UJ7DQsUEn2kh/WO3C6Ih86+cjc7+7juMMVrk4fUjJtS+UEg+7Dp5lPynFLalKr64cnV10Gddz6QRPNwWo1mZBUSPnpgZqcdGcaLGT6vPSD+32Rxj0lMtgefWB9WaerlbfPidfW4ubsxTXwPp/nx/7uGhQvt6Df/3260O3z177Ok5/rMX07ddRzbgLi1AvPVnHwj4fpSUSzHcUfKZGoy4qSh1uyVU4lFqUQ+kB67r0zlU+rEUBSNJBbzk64h0ILwU9XrG7ThULSkciUlyJAqQBqDnctg6MEUXei29YUPicUCNq9PB4uXwc1omBU8eo3b42AGPsp8Mku3WTywZq6ejMn9899+G9nWPiZdQtRMmidjKYtgCMAe3QYz8zq8PRhjLdrz0z/8/OMUXLLZq64Ii4VTP4FRqMpIzSg06bXIiCMpIIh/3el+bcPvo7DW01DTbZevNFwGW69bAnHKScBMVx9l6sN3DbfRA1Jhm4N2SbBkPH16M65l3nAiWkOoNHJniWwhq54WWdx9uQO99wh7zPs4CiZr2LJ9Pe1tST+Ad+zBvEni8rqGBMKZ7y9IuXoCb/QuZQQCCTp98m5c+jZxwGlB4Yb8g8viJz5YKQT+NWf9cxTL+hQXECMMF5iD1msqQj3FBzpTpX767+0aFN0vV221ChMBEc4m4PFui+yLRnDpU1VK05DUGqu/ojtBHycqib0+mwoSgCc+zAM+a/oY2RZUOZLoQbf2A747ZLps7lmAeU1gGmIFZ0EWb3YVA6Xt7+iitcblC+SDqPu7bgcBmvrOuVVn2WC3m4zcDBv7bDbfZ5P6iJdqPeL6Kwx+tbBhMjjzv9OvaD21Uun4iD6wfF2E+pzmxSmNRPX7idTHAeyHo4/JzghGzZQ/WDytxS/uRkovNYssUklfvBPTb6KGLOLpwLVNaWCrSDic/YT0GFQyEJbuHIu/cJB6h5bue5840achi337p5kHNLHQRHLQPrBo854e03NEuZOREES3o7eL2/YYmBE3aDwuUBBU03V2rNXXQeiKrkeQM7yDHptgyPkwcU5yQLmfQCzfRoWIjruQtcXlDUbFhgOR00ykq7sYTbMvV7j7jbMk8oemIE6vsCi7HAnC8h0/6iLJcnFHWTgSzdsk9CJ4IMy/e4STeUVzaWq1yanhq69/O16wPy1ci8PGvAgiC4az7vtN03TZmWm2g1FnKFglAm4Q0UdetnzAaYaNW/gvVyTZ7b86cpA+jCjVrzuH1tYDFTyew8Np+3zHnRj9RKzWGdPWDMMzE7jwtWw52Ldk6N1BrOjVFnDxgrdYZQykIl1Kmr5weNUdlM9osEYwNzu/hHZlgu4o/a4vLP1BsLxkZ+clBEOGqiNmqM+/V4xaiO+qMRpWYQVG5qsh1Aq9hmnUqylNHvBMbOW/KTI4LxIR3Ztu0g1wye5/njnPwyIM5RRGlxtph98Zb7rM+GY2y55T7E7AFEqpdZ0Sw+nUXMd3a5duYbO+6z53Mtp7oV4wb3dwiF+Nj5f9p5DQ5TRq+YAAAAAElFTkSuQmCC)
    100% no-repeat;
  // background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAgVBMV…AwDo/78IYCJJbI3ydLTa43N8X+Pm33hsZ+w9fhhs+JS3/jXZWY3ma7pgAAAABJRU5ErkJggg==) 50% no-repeat;
  background-size: cover;
}
.border1-top {
  position: relative;
}
.border1-top:before {
  content: "";
  pointer-events: none;
  box-sizing: border-box;
  position: absolute;
  width: 200%;
  height: 200%;
  left: 0;
  top: 0;
  border-top: 1px solid #f4f4f4;
  -webkit-transform: scale(0.5);
  -webkit-transform-origin: 0 0;
  transform: scale(0.5);
  transform-origin: 0 0;
}

.border1-bottm {
  position: relative;
}
.border1-bottm:before {
  content: "";
  pointer-events: none;
  box-sizing: border-box;
  position: absolute;
  width: 200%;
  height: 200%;
  left: 0;
  top: 0;
  border-bottom: 1px solid #f4f4f4;
  -webkit-transform: scale(0.5);
  -webkit-transform-origin: 0 0;
  transform: scale(0.5);
  transform-origin: 0 0;
}

.hasMore {
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 12px;
  color: #666;
}
.no-data {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .noInvoiceImg {
    margin-top: 60px;
    width: 310px;
    height: 200px;
  }
  .tips {
    line-height: 16px;
    margin-top: 9px;
    font-size: 16px;
    color: #999;
  }
  // .noinvoice-wrapper {
  //   text-align: center;
  //   // margin: 6rem auto;
  //   // .noinvoice {
  //   //   background-color: #fff;
  //   //   border-radius: 50%;
  //   //   font-size: 4rem;
  //   //   color: #e6e6e6;
  //   // }
  // }
}
.bg-f{
  background:#fff;
}
</style>
